const textosMx = {
  login_page_texto_recuperar_contrasena_1: "Ingresa al siguiente",
  login_page_texto_recuperar_contrasena_2: "enlace",
  login_page_texto_recuperar_contrasena_3: "para recuperar tu contraseña",
  input_usuario: "Usuario",
  input_usuario_descripcion: "Ingrese el usuario",
  input_correo: "Correo",
  input_correo_descripcion: "Ingrese el correo",
  input_contrasena: "Contraseña",
  input_contrasena_descripcion: "Ingrese la contraseña",
  input_validation_requerido: "Requerido",
  login_page_titulo: "Inicio de sesión",
  login_page_ingrese_credenciales: "Ingrese usuario y contraseña",
  login_form_component_acceder: "Acceder",
  input_validation_email_invalido: "Correo inválido",
  login_error: "Error al iniciar sesión",
  menu_home_titulo: "Menú",
  menu_regresar_inicio: "Inicio",
  menu_cerrar_sesion: "Cerrar Sesión",
  http_exito_registrar: "Éxito al registrar",
  http_error_registrar: "Error al registrar",
  input_validation_min_4: "Debe tener más de 4 caracteres",
  input_validation_max_150: "No debe tener más de 150 caracteres",
  input_validation_formato_invalido: "Formato inválido",
  input_validation_min_10_digitos: "Se requieren minimo 10 digitos",
  input_validation_max_10_digitos: "Máximo 10 digitos",
  input_validation_solo_numeros: "Sólo se permiten números",
  input_validation_password_coincidir: "Las contraseñas no coinciden",
  set_general_editar_usuario: "Editar usuario",
  input_telefono: "Teléfono",
  general_desactivar_usuario: "Desactivar usuario",
  general_editar_usuario: "Editar usuario",
  input_nombre: "Nombre",
  usuario_editado_correctamente: "Usuario editado correctamente",
  reactivado_correctamente: "Usuario reactivado correctamente",
  desactivado_correctamente: "Usuario desactivado correctamente",
  input_password: "Contraseña",
  input_password_confirm: "Confirmar contraseña",
  iniciar_sesion: "Iniciar Sesión",
  recupera_password_page_titulo: "Recuperar contraseña",
  recupera_password_ingresa_correo: "Ingresa el correo de tu cuenta",
  recuperacion_contrasena_inicio_proceso_exito:
    "Se envió el link a tu correo para recuperar la contraseña",
  password_recover_validacion_page_titulo: "Actualización de la contraseña",
  input_contrasena_confirmacion: "Confirma contraseña",
  general_actualizar_contra: "Actualizar contraseña",
  recuperacion_contrasena_exito_al_actualizar: "Exito al actualizar la contraseña",
  password_recover_validacion_page_token_invalido: "El token proporcionado es inválido",
  no_hay_categorías_registradas: "No hay categorías registradas",
  general_añadir: "Añadir",
  general_editar: "Editar",
  input_clave: "Clave",
  input_nombre: "Nombre",
  input_descripcion: "Descripción",
  general_añadiendo: "Añadiendo",
  categoria_añadida_correctamente: "Categoría añadida correctamente",
  error_añadir_categoria: "Error al añadir la categoría",
  categoria_desactivada_correctamente: "Categoría desactivada correctamente",
  categoria_desactivada_error: "Error al desactivar la categoría",
  categoria_activada_correctamente: "Categoría activada correctamente",
  categoria_activada_error: "Error al activar la categoría",
  categoria_editada_correctamente: "Categoría editada correctamente",
  categoria_editada_error: "Error al editar la categoría",
  añadir_categoria: "Añadir categoría",
  general_añadido_correctamente: "Añadido correctamente",
  error_añadir_general: "Error al añadir",
  general_editado_correctamente: "Editado correctamente",
  general_editado_error: "Error al editar",
  general_desactivado_correctamente: "Desactivado correctamente",
  general_desactivado_error: "Error al desactivar",
  general_activado_correctamente: "Activado correctamente",
  general_activado_error: "Error al activar",
  general_editando: "Editando",
  añadir_tipo_producto: "Añadir tipo producto",
  no_hay_datos_registrados: "No hay datos registrados",
  añadir_unidad_medida: "Añadir unidad de medida",
  select_almacen: "Almacén",
  sin_almacenes_registrados: "Sin almacenes registrados",
  añadir_ubicacion: "Añadir ubicación",
  añadir_producto: "Añadir producto",
  input_buscador: "Buscar",
  producto_sin_stock: "Sin stock",
  select_unidad_medida: "Unidad de medida",
  select_categoria: "Categoría",
  select_ubicacion: "Ubicación",
  select_tipo_producto: "Tipo de producto",
  input_maximos: "Máximos",
  input_minimos: "Mínimos",
  input_punto_reorden: "Punto de reorden",
  producto_desactivado: "Desactivado",
  general_desactivar: "Desactivar",
  general_activar: "Activar",
  select_usuario: "Selecciona usuario",
  nueva_requisicion: "Nueva requisición",
  general_cargando_datos: "Cargando datos...",
  general_ver_detalles: "Ver detalles",
  general_enviar_autorizar: "Enviar a autorizar",
  general_enviado_autorizar_correctamente: "Enviado a autorizar correctamente",
  general_enviado_autorizar_error: "Error al enviar a autorizar",
  general_cotizar: "Cotizar",
  general_enviando_dg_correctamente: "Enviado a DG correctamente",
  general_autorizado_correctamente: "Autorizado correctamente",
  general_autorizado_error: "Error al autorizar",
  general_autorizar: "Autorizar",
  general_seleccionar_accion: "Selecciona una acción",
  general_autorizado_error: "Error al actualizar",
  general_rechazado_error: "Error al rechazar",
  general_enviando_dg_error: "Error al enviar a DG",
  general_mandar_daf_correctamente: "Mandado a DAF correctamente",
  general_mandar_daf_error: "Error al mandar a DAF",
  general_mandar_daf: "Mandar a DAF",
  general_rechazado_correctamente: "Rechazado correctamente",
  selecciona_tipo_producto: "Selecciona el tipo de producto",
  nuevo_proveedor: "Nuevo proveedor",
  input_codigo: "Código",
  input_razon_social: "Razón social",
  input_nombre_comercial: "Nombre comercial",
  input_direccion: "Dirección",
  input_contacto: "Contacto",
  input_giro: "Giro",
  input_importe_credito: "Importe crédito",
  input_dias_credito: "Días de crédito",
  input_tiempo_entrega: "Tiempo de entrega",
  input_precio: "Precio",
  general_sin_registros: "Sin registros",
  input_observaciones: "Observaciones",
  cotizacion_creada_correctamente: "Cotización creada correctamente",
  cotizacion_creada_error: "Error al crear la cotización",
  registrar_precio: "Registrar precio",
  no_disponible: "No disponible",
  general_registrar_precio_correctamente: "Precio registrado correctamente",
  general_registrar_precio_error: "Error al registrar el precio",
  general_marcar_no_disponible_correctamente: "Marcado como no disponible correctamente",
  general_marcar_no_disponible_error: "Error al marcar como no disponible",
  general_registrar: "Registrar",
  general_registrando: "Registrando",
  input_precio_unitario: "Precio unitario",
  general_ver_datos: "Ver datos",
  general_generar_orden_compra: "Generar orden de compra",
  general_generando: "Generando",
  orden_compra_añadida_correctamente: "Orden de compra añadida correctamente",
  error_añadir_orden_compra: "Error al añadir la orden de compra",
  general_aceptar: "Aceptar",
  general_aceptada_correctamente: "Aceptada correctamente",
  general_aceptada_error: "Error al aceptar",
  validar_xml_factura: "Validar XML de la factura",
  validar_xml: "Validar XML",
  subir_pdf_factura_placeholder: "Subir PDF de la factura",
  subir_pdf_factura: "Subir PDF y surtir",
  pdf_factura_subido_correctamente: "PDF Subido y Orden surtida correctamente",
  factura_validada_error: "Error al subir el PDF",
  general_marcar_atendida: "Marcar como atendida",
  general_marcar_atendido_correctamente: "Requisición marcada como atendida correctamente",
  factura_validada_correctamente: "Factura validada correctamente",
  general_ver_bitacora: "Ver bitácora",
  general_documentos: "Documentos",
  select_documento: "Seleccionar tipo de documento",
  subir_documento_placeholder: "Subir tu documento",
  subir_documento: "Subir documento",
  general_subido_correctamente: "Subido correctamente",
  general_subido_error: "Error al subir",
  general_ver_documento: "Ver documento",
  general_añadir_requisicion: "Añadir requisición",
  input_cantidad: "Cantidad",
  general_surtir_disponible: "Surtir lo disponible",
  general_surtido_correctamente: "Surtido correctamente",
  general_surtido_error: "Error al surtir",
  general_producto_gestionado_correctamente: "Cotización gestionada y enviada a compras",
  general_producto_gestionado_error: "Error al enviar la cotización a compras",
  select_empresa: "Empresa",
  editar_documento: "Editar documento",
  general_eliminado_correctamente: "Eliminado correctamente",
  general_eliminar: "Eliminar",
  input_rfc: "RFC",
  error_editado_general: "Error editando",
  input_referencias: "Referencias/comentarios",
  subir_imagen_referencia_placeholder: "Imagen de referencia",
  subir_logo_empresa_placeholder: "Logo de la empresa",
  nueva_empresa: "Nueva empresa",
  sin_documentos_registrados: "Sin documentos registrados",
  sin_ubicaciones_registradas: "Sin ubicaciones registradas",
  input_puntoReorden: "Punto de reorden",
  general_estatus: "Estatus",
  general_activo: "Activo",
  general_actualizado_correctamente: "Actualizado correctamente",
  error_actualizar_general: "Error al actualizar",
  enviar_a_dg: "Enviar a DG",
  general_cancelar: "Cancelar",
  general_confirmar: "Confirmar",
  general_rechazar: "Rechazar",
  general_cancelar_correctamente: "Cancelada correctamente",
  general_cancelar_error: "Error al cancelar",
  sin_tipos_producto_registrados: "No hay tipos registrados",
  general_reabriendo: "Reabriendo...",
  general_reabrir_requisicion: "Reabrir requisición",
  general_entregado_correctamente: "Producto entregado correctamente",
  general_entregado_error: "Error al entregar el producto",
  reportar_problema_datos: "Reportar problema a FH",
  general_reportado_correctamente: "Problema reportado correctamente",
  general_reportado_error: "Error al reportar el problema",
  general_mandar_autorizar_computo: "Mandar a autorizar equipo",
  general_enviando: "Enviando",
  enviado_autorizar_correctamente: "Enviado a autorizar correctamente",
  enviado_autorizar_error: "Error al enviar a autorizar",
  general_generar_qr: "Generar QR",
  general_generando_qr: "Generando QR..."
};

export default textosMx;
